import React, { useEffect } from 'react'
import axios from 'axios'
import useAxios from 'axios-hooks'
import { SubmissionError } from 'redux-form/immutable'
import parseQueryString from 'utils/routing'
import history from 'configureHistory'

import Form from './Form'

const ResetPasswordPage = ({ location }) => {
	const params = location.search ? parseQueryString(location.search) : null

	const t = params.t || null

	useEffect(() => {
		const checkReset = async () => {
			try {
				await axios.post(`auth/check-password-reset`, {
					token: t,
				})
			} catch (error) {
				history.replace({
					pathname: '/login',
					state: {
						loginMessage: 'errors.password_reset_token_invalid',
					},
				})
			}
		}

		checkReset()
	}, [t])

	const [, executePost] = useAxios(
		{
			url: 'auth/perform-password-reset',
			method: 'POST',
		},
		{ manual: true }
	)

	const handleSubmit = async ({ password }) => {
		try {
			await executePost({ data: { token: t, password } })

			history.replace({
				pathname: '/login',
				state: {
					loginMessage: 'forgot_password_reset_successfully',
				},
			})
		} catch (error) {
			throw new SubmissionError({
				// email: 'User does not exist',
				_error: error.response.data.message,
			})
		}
	}

	return <Form onSubmit={handleSubmit} />
}

export default ResetPasswordPage
